/* eslint-disable max-len */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/default-props-match-prop-types */
import { Box } from '@mui/material'
import React, { useContext } from 'react'
import videojs from 'video.js'
import Player from 'video.js/dist/types/player'
import 'video.js/dist/video-js.css'
import * as styles from './Video.module.scss'
import './videojs.css'
import HistoryContext from '../../context/HistoryContext'

type PlayerOptions = {
  [key: string]: any
  //https://github.com/videojs/video.js/issues/8646
  cover?: boolean
}

type Props = {
  sources: { src: string; type?: string; withCredentials?: boolean }[]
  options: PlayerOptions
  onReady?: (player: Player) => void
  thumbnailSrc?: string
  className?: string
  linkHref?: string
  linkTarget?: string
}

export const Video = React.memo(
  (props: Props) => {
    const history = useContext(HistoryContext)
    const videoRef = React.useRef<HTMLDivElement>(null)
    const playerRef = React.useRef<Player | null>(null)
    const [isLoaded, setIsLoaded] = React.useState(false)

    const { options, onReady } = props

    React.useEffect(() => {
      if (!playerRef.current && videoRef.current) {
        const videoElement = document.createElement('video-js')
        videoElement.classList.add('vjs-big-play-centered')

        if (props.options.coverFit) {
          videoElement.classList.add('bs-video-cover-fit')
        }

        videoRef.current.appendChild(videoElement)

        // eslint-disable-next-line no-multi-assign
        const player = (playerRef.current = videojs(
          videoElement,
          {
            controlBar: {
              pictureInPictureToggle: false,
            },
            ...options,
          },
          () => {
            const _player = playerRef.current
            if (_player) {
              _player.src(props.sources)
              // _player.muted(options.muted || true)
              if (options.aspectRatio) {
                _player.aspectRatio(options.aspectRatio)
              }
              _player.fluid(options.fluid !== undefined ? options.fluid : false)
              _player.fill(options.fill !== undefined ? options.fill : false)
              _player.responsive(options.responsive !== undefined ? options.responsive : true)
              _player.controls(options.controls !== undefined ? options.controls : false)
              _player.loop(options.loop !== undefined ? options.loop : true)
              _player.preload(options.preload !== undefined ? options.preload : 'auto')
              _player.playsinline(true)
              _player.muted(true)
              _player.play()?.catch(e => {
                console.warn('Auto-play blocked:', e)
              })
              _player.enableTouchActivity()
              _player.on('canplay', () => {
                if (!isLoaded) {
                  setIsLoaded(true)
                }
              })

              //debug
              // _player.on('error', () => {
              //   console.error('Video.js error', _player.error())
              // })

              // _player.on('loadedmetadata', () => {
              //   console.log('loadedmetadata')
              // })
              // _player.on('loadeddata', () => {
              //   console.log('loadeddata')
              // })
              // _player.on('waiting', () => {
              //   console.log('waiting')
              // })
              // _player.on('playing', () => {
              //   console.log('playing')
              // })
            }

            onReady && onReady(player)
          },
        ))
      }
    }, [options, JSON.stringify(props.sources), playerRef.current, videoRef.current])

    React.useEffect(() => {
      const player = playerRef.current

      return () => {
        if (player && !player.isDisposed()) {
          player.dispose()
          playerRef.current = null
        }
      }
    }, [playerRef.current])

    let thumb = null
    if (!isLoaded && props.thumbnailSrc) {
      thumb = <img src={props.thumbnailSrc} alt="thumb" className={props.className} />
    }

    let linkOverlay = null
    if (props.linkHref) {
      //linkOverlay = <a href={props.linkHref} target={props.linkTarget} className={styles['video__link']} aria-label="link" />
      linkOverlay = (
        <div
          onClick={() => {
            if (props.linkTarget === '_blank') {
              window.open(props.linkHref, '_blank', 'noopener,noreferrer')
            } else {
              history.push({
                pathname: props.linkHref,
              })
            }
          }}
          className={styles['video__link']}
          aria-label="link"
        />
      )
    }

    return (
      <div className={styles.video}>
        {linkOverlay}
        {thumb}
        <div
          data-vjs-player
          className={`${styles['video__player']} ${props.className ? props.className : ''}  ${isLoaded ? '' : styles['video__player--hidden']}`}
        >
          <div ref={videoRef} className={`${styles.refBox} ${props.options.cover ? 'vjs-cover' : ''} `} />
        </div>
      </div>
    )
  },
  (prevProps, nextProps) => {
    const sourcesEqual = JSON.stringify(prevProps.sources) === JSON.stringify(nextProps.sources)
    const optionsEqual = JSON.stringify(prevProps.options) === JSON.stringify(nextProps.options)
    return sourcesEqual && optionsEqual
  },
)

export default Video
